
import { Component, Vue, Prop } from 'vue-property-decorator';

import { sharedState } from '../../../../framework/state';

import VehicleUsages from '../../admin/vehicle-usage/VehicleUsages.vue';
import VehicleMonthlyMileageChart from '../../manager/report/VehicleMonthlyMileageChart.vue';
import VehicleMonthlyConsumptionChart from '../../manager/report/VehicleMonthlyConsumptionChart.vue';
import VehicleMonthlyCO2Chart from './VehicleMonthlyCO2Chart.vue';
import VehicleMonthlyAverageMileageChart from './VehicleMonthlyAverageMileageChart.vue';
import { getResourcesNew } from '../../../../framework/client/resource';
import { VehicleUsage } from '../../../../../common/application/model/VehicleUsage';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';

@Component({
    components: {
        VehicleUsages,
        VehicleMonthlyMileageChart,
        VehicleMonthlyConsumptionChart,
        VehicleMonthlyCO2Chart,
        VehicleMonthlyAverageMileageChart,
    },
})
export default class VehicleUsageReports extends Vue {
    readonly resourceType = ApplicationResource.VEHICLE_USAGE;
    @Prop(String) readonly vehicleContractId!: string;

    shared = sharedState;

    local = {
        vehicleUsageData: [] as VehicleUsage[],
    };

    mounted() {}

    private async loadAsyncData(): Promise<void> {
        const vehicleUsageParameters = new Map<string, string>([
            ['vehicleContractId', this.vehicleContractId],
            ['page', '1'],
            ['sortField', 'vehicleUsageDate'],
            ['sortOrder', 'desc'],
            ['pageSize', '12'],
        ]);

        this.local.vehicleUsageData = await getResourcesNew<VehicleUsage>(
            this.resourceType,
            parseInt(vehicleUsageParameters.get('page') || '1'),
            vehicleUsageParameters,
        );
    }
}
